/**
 * storage-keys.ts — chaves centralizadas do localStorage do FloraSegura.
 *
 * Importe daqui em vez de declarar strings locais nos componentes.
 */

export const LS_VET      = 'florasegura:saved-vet'
export const LS_AVATAR   = 'florasegura:perfil-avatar'
export const LS_ANIMALS  = 'florasegura:user-animals'
export const LS_NOTIF    = 'florasegura:notif-enabled'
export const LS_DEMO     = 'florasegura:demo-user'
export const LS_ONBOARDING = 'florasegura:onboarding-done'
export const LS_TEXT_SIZE  = 'florasegura-textSize'
export const LS_LAST_TOXIC = 'florasegura_last_toxic_result'
export const LS_MEUS_DADOS = 'florasegura:perfil-meus-dados'
// trigger redeploy 03/05/2026
// trigger 1777784369822
export const LS_LAST_TOXIC_PLANT = 'florasegura:last-toxic-plant'
